import { Api } from '@sodamnfoolish/sjc-backend-types';

export function calculateBondingCurveProgress(virtualTokenReserves: string): number {
    const bondingCurveProgress = ((1_073_000_000 * 10 ** 6 - Number(virtualTokenReserves)) * 100) / (793_100_000 * 10 ** 6);
    return bondingCurveProgress < 1 ? 1 : bondingCurveProgress;
}

export function getBondingCurveProgress(token: Api.Pump.DTO.PumpFunToken): number {
    return calculateBondingCurveProgress(token.virtualTokenReserves);
}

export function calculateMarketCap(token: Api.Pump.DTO.PumpFunToken, solPriceUsd: number): number {
    const sol = Number(token.virtualSolReserves) / 1_000_000_000;

    return sol * solPriceUsd;
}
